import { GenericState } from '@core/models/request-status.model';
import { PaymentMethod, B2BUnit } from '@b2b/features/b2b-unit/core/b2b-unit.model';

export interface B2bUnitState {
  currentB2bUnit: GenericState<B2BUnit | null>;
  paymentMethods: GenericState<PaymentMethod[]>;
  defaultPaymentMethod: GenericState<PaymentMethod | null>;
}

export const B2B_UNIT_FEATURE = 'B2B_UNIT';
